export const authApi = {
    mobile: "v1/accounts/support/auth",
    verify_code: "v1/accounts/support/verify",
    resend_code: "v1/accounts/support/resend",
    profile: "v1/accounts/support/info"
}

export const auxiliaryApi = {
    upload_image: "v1/auxiliary/support/upload/image",
    attributes: "v1/attributes/support/list"
}

export const podcastsApi = {
    list: "v1/multi-media/support/podcasts/list",
    create: "v1/multi-media/support/podcasts/create",
    status: "v1/multi-media/support/podcasts/status",
    update: "v1/multi-media/support/podcasts/update",
    user_favorite_list: "v1/multi-media/support/podcasts/user/favorite",
    user_rate_list: "v1/multi-media/support/podcasts/user/rate",
}

export const videosApi = {
    list: "v1/multi-media/support/videos/list",
    create: "v1/multi-media/support/videos/create",
    status: "v1/multi-media/support/videos/status",
    update: "v1/multi-media/support/videos/update",
    user_favorite_list: "v1/multi-media/support/videos/user/favorite",
    user_rate_list: "v1/multi-media/support/videos/user/rate",
}

export const eventsApi = {
    list: "v1/events/support/list",
    create: "v1/events/support/create",
    status: "v1/events/support/status",
    update: "v1/events/support/update",
}

export const blogsApi = {
    categories_list: "v1/blogs/support/categories/list",
    list: "v1/blogs/support/list",
    category_list: "v1/blogs/support/categories-list",
    create: "v1/blogs/support/create",
    status: "v1/blogs/support/status",
    update: "v1/blogs/support/update",
}

export const contactUsApi = {
    list: "v1/auxiliary/support/contact-us/list",
    status: "v1/auxiliary/support/contact-us/status",
}

export const usersApi = {
    list: "v1/accounts/support/list",
    create: "v1/accounts/support/create",
    status: "v1/accounts/support/status",
    profile: "v1/accounts/support/profile",
    wallet_info: "v1/wallets/support/user/info",
    wallet_transactions: "v1/wallets/support/user/transactions",
}

export const productsApi = {
    list: "v1/products/support/list",
    list_title: "v1/products/support/list-title",
    create: "v1/products/support/create",
    status: "v1/products/support/status",
    update: "v1/products/support/update",
}

export const videoProductApi = {
    list: "v1/video_product/support/list",
    list_title: "v1/video_product/support/list-title",
    create: "v1/video_product/support/create",
    status: "v1/video_product/support/status",
    update: "v1/video_product/support/update",
    user_list: "v1/video_product/support/user/list",
    user_create: "v1/video_product/support/user/create",
    user_status: "v1/video_product/support/user/status",
    user_favorite_list: "v1/video_product/support/user/favorite/list",
    user_like_list: "v1/video_product/support/user/like/list",
    user_rate_list: "v1/video_product/support/user/rate/list",
    teachers_list: "v1/video_product/support/teachers/list",
    counseling_list: "v1/video_product/support/counseling/list",
    counseling_status: "v1/video_product/support/counseling/status",
    categories_list: "v1/video_product/support/video-products-categories/list",
    categories_create: "v1/video_product/support/video-products-categories/create",
    categories_delete: "v1/video_product/support/video-products-categories/delete",
    categories_status: "v1/video_product/support/video-products-categories/status",
    special_attributes_list: "v1/video_product/support/special-attributes/list",
    special_attributes_create: "v1/video_product/support/special-attributes/create",
    special_attributes_delete: "v1/video_product/support/special-attributes/delete",
    special_attributes_update: "v1/video_product/support/special-attributes/update",
    special_attributes_status: "v1/video_product/support/special-attributes/status",
    attributes_list: "v1/video_product/support/attributes/list",
    attributes_create: "v1/video_product/support/attributes/create",
    attributes_delete: "v1/video_product/support/attributes/delete",
    attributes_update: "v1/video_product/support/attributes/update",
    attributes_status: "v1/video_product/support/attributes/status",
}

export const categoriesInVideoProductApi = {
    list: "v1/video_product/support/categories/list",
    list_title: "v1/video_product/support/categories/list-title",
    create: "v1/video_product/support/categories/create",
    status: "v1/video_product/support/categories/status",
    update: "v1/video_product/support/categories/update",
    videos_products_list: "v1/video_product/support/categories/videos-products/list",
    videos_products_create: "v1/video_product/support/video-products-categories/create",
    videos_products_delete: "v1/video_product/support/video-products-categories/delete",
    videos_products_status: "v1/video_product/support/video-products-categories/status",
    files_list: "v1/video_product/support/categories/files/list",
    files_delete: "v1/video_product/support/categories/files/delete",
    files_add: "v1/video_product/support/categories/files/create",
    files_status: "v1/video_product/support/categories/files/status",
}

export const fileForCategoriesInVideoProductApi = {
    list: "v1/video_product/support/files/list",
    list_title: "v1/video_product/support/files/list-title",
    create: "v1/video_product/support/files/create",
    status: "v1/video_product/support/files/status",
    update: "v1/video_product/support/files/update"
}

export const teachersApi = {
    list: "v1/teachers/support/list",
    list_name: "v1/teachers/support/list-name",
    create: "v1/teachers/support/create",
    status: "v1/teachers/support/status",
    update: "v1/teachers/support/update",
    social_network_list: "v1/teachers/support/social-network/list",
    social_network_create: "v1/teachers/support/social-network/create",
    social_network_status: "v1/teachers/support/social-network/status",
    social_network_update: "v1/teachers/support/social-network/update",
    attachment_list: "v1/teachers/support/attachments/list",
    attachment_create: "v1/teachers/support/attachments/create",
    attachment_status: "v1/teachers/support/attachments/status",
    attachment_update: "v1/teachers/support/attachments/update",
    videos_products_list: "v1/teachers/support/video-product/list",
    videos_products_create: "v1/teachers/support/video-product/create",
    videos_products_delete: "v1/teachers/support/video-product/delete",
    videos_products_status: "v1/teachers/support/video-product/status",
}

export const commentsApi = {
    list: "v1/comments/support/list",
    user_list: "v1/comments/support/user/list",
    update: "v1/comments/support/update",
    status: "v1/comments/support/update",
}

export const ticketsApi = {
    list: "v1/tickets/support/list",
    user_list: "v1/tickets/support/user/list",
    new: "v1/tickets/support/new/create/",
    update: "v1/tickets/support/reply/update",
}

export const basketApi = {
    user_basket: "v1/baskets/support/user",
    list: "v1/baskets/support/list",
    view: "v1/baskets/support/view",
}

export const couponsApi = {
    list: "v1/coupons/support/list",
    status: "v1/coupons/support/status",
    create: "v1/coupons/support/create",
    update: "v1/coupons/support/update",
}

export const purchasesApi = {
    list: "v1/purchases/support/list",
    user_list: "v1/purchases/support/user/list",
    details: "v1/purchases/support/details",
}

export const paymentsApi = {
    purchases_list: "v1/finance/support/payments/purchases",
    wallets_list: "v1/finance/support/payments/wallets",
}